import { createFileRoute } from '@tanstack/react-router'
import { OptimizationOverview } from '@/features/optimization/overview'

export const Route = createFileRoute('/_authenticated/optimization/')({
  component: OptimizationOverview,
})
